(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(5838);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5896);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8109);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(624);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1156);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(177);
/* harmony import */ var _comps_cookies__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1579);
/* harmony import */ var _comps_favicon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7953);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6254);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2213);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4382);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(9521);
/* harmony import */ var _careers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5914);
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2673);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1816);
/* harmony import */ var _utils_googleapi__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9872);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4371);
/* harmony import */ var _utils_coins__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(279);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2010);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(259);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8767);
/* harmony import */ var _comps__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8014);
/* harmony import */ var _sections_editor_editor__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5091);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  min-height: 1500px;\n\n  @media ",
        " {\n    height: 100vh;\n    min-height: 1300px;\n  }\n\n  @media ",
        " {\n    min-height: 1200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  flex: 1;\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n  justify-content: center;\n\n  gap: 28px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: flex-end;\n\n  gap: 8px;\n\n  width: var(--w-screen);\n  min-width: 1000px;\n\n  margin-bottom: -100px;\n\n  @media ",
        " {\n    margin-bottom: -150px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  gap: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  height: 200px;\n\n  @media ",
        " {\n    height: 350px;\n  }\n\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  bottom: 0;\n\n  .light & {\n    background: linear-gradient(\n      180deg,\n      rgba(245, 246, 252, 0) 0%,\n      #f5f6fc 109.43%\n    );\n  }\n\n  .dark & {\n    background: linear-gradient(\n      180deg,\n      rgba(18, 18, 18, 0) 0,\n      #121212 109.43%\n    );\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 31px;\n  line-height: 37px;\n\n  color: var(--color-blue-900);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n\n  color: var(--color-blue-900);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}























var columns = [
    [
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/0-0.webp"),
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/0-1.webp")
    ],
    [
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/1-0.webp"),
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/1-1.webp")
    ],
    [
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/2-0.webp"),
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/2-1.webp")
    ],
    [
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/3-0.webp")
    ],
    [
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/4-0.webp"),
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/4-1.webp")
    ],
    [
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/5-0.webp"),
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/5-1.webp")
    ],
    [
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/6-0.webp"),
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/6-1.webp"),
        (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/404/6-2.webp"), 
    ], 
];
var Container = styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e54a3a8f-0"
})(_templateObject(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.desktop */ .Hb.desktop);
var Body = styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e54a3a8f-1"
})(_templateObject1());
var ImageColumns = styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e54a3a8f-2"
})(_templateObject2(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.desktop */ .Hb.desktop);
var SingleColumn = styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e54a3a8f-3"
})(_templateObject3());
var BottomGradient = styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e54a3a8f-4"
})(_templateObject4(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.desktop */ .Hb.desktop);
var OopsText = styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-e54a3a8f-5"
})(_templateObject5());
var SubtitleText = styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-e54a3a8f-6"
})(_templateObject6());
var NotFound = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_meta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: t("txt_404_title"),
                description: t("txt_404_title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps__WEBPACK_IMPORTED_MODULE_20__/* .Header */ .h4, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Body, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                        height: 100
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OopsText, {
                        children: "404"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubtitleText, {
                        children: t("txt_not_found")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        href: "/",
                        primary: true,
                        text: "txt_take_me_back"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageColumns, {
                        children: columns.map(function(column, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SingleColumn, {
                                children: column.map(function(image, j) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        src: image,
                                        alt: "404 image"
                                    }, j);
                                })
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BottomGradient, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_footer__WEBPACK_IMPORTED_MODULE_3__/* .WrappedFooter */ .M, {})
        ]
    });
};
NotFound.Layout = function Layout(props) {
    var children = props.children, theme = props.theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(next_themes__WEBPACK_IMPORTED_MODULE_17__/* .ThemeProvider */ .f, {
        attribute: "class",
        forcedTheme: theme,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_careers__WEBPACK_IMPORTED_MODULE_11__.GlobalStyle, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_query__WEBPACK_IMPORTED_MODULE_19__.QueryClientProvider, {
                client: _app__WEBPACK_IMPORTED_MODULE_12__.queryClient,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_client_auth__WEBPACK_IMPORTED_MODULE_13__/* .ClientSideAuthProvider */ .s5, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_notification__WEBPACK_IMPORTED_MODULE_15__/* .NotificationProvider */ .J, {
                        timeout: 3000,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_18__/* .GoogleReCaptchaProvider */ .pm, {
                            scriptProps: {
                                async: true
                            },
                            reCaptchaKey: "6LelseIjAAAAAEmIkD3assuAQxcbF9vd0zbE-jMG",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_coins__WEBPACK_IMPORTED_MODULE_16__/* .CoinsProvider */ ._k, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_utils_adjust__WEBPACK_IMPORTED_MODULE_8__/* .AdjustProvider */ .xF, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_favicon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_cookies__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_editor_editor__WEBPACK_IMPORTED_MODULE_21__/* .EditorParamsProviders */ .i9, {
                                            children: children
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_adjust__WEBPACK_IMPORTED_MODULE_8__/* .UsePageViewEvent */ .rs, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_googleapi__WEBPACK_IMPORTED_MODULE_14__/* .GoogleOneTap */ .K, {})
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (NotFound);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5914,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);